import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetPerformanceSummaryArgs } from "../schemas";

const getPerformanceSummaryQueryKey = (args: GetPerformanceSummaryArgs) =>
  ["getPerformanceSummary", args.health_care_organization_id, args.params] as const;

export const useGetPerformanceSummary = (args: GetPerformanceSummaryArgs) => {
  const client = useApiClient();

  return useQuery(getPerformanceSummaryQueryKey(args), () => client.getPerformanceSummary(args));
};
